import styled from 'styled-components';
import font from '@theme/font';
import colors from '@theme/colors';

const Container = styled.div`
  display: flex;
`;
const Title = styled.div`
  font-weight: bold;
  width: 70px;
  margin-right: 10px;

  @media screen {
    font-size: ${font.screen.size.MEDIUM};
    line-height: ${font.screen.lineHeight.MEDIUM};

    @media (max-width: 740px) {
      font-size: ${font.mobile.size.MEDIUM};
      line-height: ${font.mobile.lineHeight.MEDIUM};
      margin-right: 0;
    }
  }
  @media print {
    font-size: ${font.print.size.MEDIUM};
    line-height: ${font.print.lineHeight.MEDIUM};
  }
`;
const List = styled.ul`
  margin: 0px;
  padding-left: 20px;
  list-style-type: none;
  @media screen {
    font-size: ${font.screen.size.MEDIUM};
    line-height: ${font.screen.lineHeight.MEDIUM};

    @media (max-width: 740px) {
      font-size: ${font.mobile.size.MEDIUM};
      line-height: ${font.mobile.lineHeight.MEDIUM};
    }
  }
  @media print {
    font-size: ${font.print.size.MEDIUM};
    line-height: ${font.print.lineHeight.MEDIUM};
`;

const MainContainer = styled.div`
  margin-bottom: 40px;
  @media (max-width: 740px) {
    margin-bottom: 25px;
  }
  &:last-child hr {
    display: none;
  }
`;

const Hr = styled.hr`
  border: none;
  border-bottom: 1px solid ${colors.PRIMARY};
  width: 75%;
  margin-top: 40px;
`;

const H2 = styled.h2`
  * {
    font-family: Lato, sans-serif !important;
  }
  font-weight: normal;
  font-size: 1.5em;
  color: ${colors.PRIMARY};
`;

const A = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    cursor: pointer;
  }
`;

export default {
  Container,
  Title,
  List,
  MainContainer,
  Hr,
  H2,
  A,
};



// WEBPACK FOOTER //
// ./components/layout/TranscriptBlockContainer.js